
const common = require("lib/labels/_common");

// Home.backoffice.groups

module.exports = {
  groupForm: {
    stepTitle: {
      en: "Group",
      fr: "Groupe"
    },
    title: {
      creation: {
        en: "New group",
        fr: "Nouveau groupe"
      },
      edition: {
        en: "group edition",
        fr: "Edition de groupe"
      }
    },
    name: {
      label: common.name,
      text: {
        en: "Give an group name",
        fr: "Donnez un nom au groupe"
      }
    },
    type: {
      label: {
        en: "Type",
        fr: "Type"
      },
      text: {
        en: "Provide the group type",
        fr: "Donnez le type de groupe"
      }
    },
    email: {
      label: {
        en: "Email",
        fr: "Email"
      }
    },
    address: {
      label: {
        en: "Address",
        fr: "Adresse"
      }
    },
    phone: {
      label: {
        en: "Phone",
        fr: "Téléphone"
      }
    },
    company: common.company,
    service: common.service
  },
  appsForm: {
    stepTitle: common.apps,
    title: {
      creation: common.apps,
      edition: common.apps
    }
  },
  adminForm: {
    stepTitle: {
      en: "Administrator",
      fr: "Administrateur"
    },
    alreadyExist: {
      en: "already exist",
      fr: "existe déjà"
    },
    title: {
      creation: {
        en: "Administrator",
        fr: "Administrateur"
      },
      edition: {
        en: "Administrator",
        fr: "Administrateur"
      }
    },
    login: {
      en: "Login",
      fr: "Identifiant"
    },
    password: common.password,
    email: {
      label: common.email,
      invalid: {
        en: "Invalid email",
        fr: "Email invalid"
      }
    }
  },
  profileForm: {
    admin: {
      en: "Administrator",
      fr: "Administrateur"
    },
    manager: {
      en: "Manager",
      fr: "Manager"
    },
    user: {
      en: "User",
      fr: "Utilisateur"
    },
    selectAll: {
      en: "Select all",
      fr: "Tout sélectionner"
    },
    unselectAll: {
      en: "Unselect all",
      fr: "Tout désélectionner"
    },
    adminRights: {
      en: "Administrator's rights",
      fr: "Droits d'administrateur"
    },
    managerRights: {
      en: "Manager's rights",
      fr: "Droits de manager"
    },
    userRights: {
      en: "User's rights",
      fr: "Droits d'utilisateur"
    },
  },
  ...require("./profiles").profileForm,
  groupList: {
    title: {
      en: "groups",
      fr: "Groupes"
    },
    title_delete_check: common.title_delete_check,
    content_delete_check: common.content_delete_check,
    no: common.no,
    yes: common.yes,
    edit: common.edit,
    remove: common.remove,
    detailed: {
      type: {
        en: "Type",
        fr: "Type"
      },
      email: common.email,
      address: {
        en: "Address",
        fr: "Adresse"
      },
      phone: {
        en: "Phone",
        fr: "Téléphone"
      },
      members: {
        en: "Members",
        fr: "Membres"
      },
      guests: {
        en: "Guests",
        fr: "Invités"
      },
      projects: common.projects
    }
  }
};
